/**
 * PreRuleScreen Component
 * Displays pre-question rule before a question
 */
import React from 'react';
import { PreQuestionRule } from '../../types';
import Timer from '../Timer';

interface PreRuleScreenProps {
  rule: PreQuestionRule;
  questionId: string;
  onComplete: () => void;
}

export const PreRuleScreen: React.FC<PreRuleScreenProps> = ({
  rule,
  questionId,
  onComplete
}) => (
  <div className="min-h-screen bg-neutral flex items-center justify-center p-4">
    <div className="bg-white rounded-xl shadow-xl p-6 max-w-xl w-full">
      {/* Rule type badge */}
      <div className={`inline-block px-4 py-2 rounded-lg mb-4 text-sm font-semibold ${
        rule.is_modification 
          ? 'bg-red-100 text-red-800' 
          : 'bg-blue-100 text-blue-800'
      }`}>
        {rule.is_modification ? 'CHANGEMENT DE REGLE' : 'Nouvelle regle'}
      </div>
      
      {/* Timer if duration specified */}
      {rule.duration_seconds && (
        <div className="mb-4">
          <Timer 
            duration={rule.duration_seconds} 
            onComplete={onComplete}
            key={`pre-rule-${questionId}`}
          />
        </div>
      )}
      
      <h2 className="text-2xl font-bold text-primary mb-4">{rule.title}</h2>
      
      <p className="text-gray-700 text-base mb-5 whitespace-pre-line leading-relaxed">
        {rule.content}
      </p>
      
      <button 
        onClick={onComplete} 
        className="w-full bg-secondary hover:bg-opacity-90 text-white font-bold py-3 rounded-lg text-base transition"
      >
        Continuer
      </button>
    </div>
  </div>
);

export default PreRuleScreen;
